<template>
  <div>
    <a-form
      @submit="submit"
      :data="data"
      ref="form"
      :form="form"
    >
      <a-tabs defaultActiveKey="1">
        <a-tab-pane
          tab="基本信息"
          key="1"
        >
          <a-row class="form-row">
            <a-col>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="姓名"
              >
                <a-input
                  placeholder="司机姓名"
                  v-decorator="[
                    'name',
                    {
                      initialValue: data.name,
                      rules: [{ required: true, message: '司机姓名' }],
                    },
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="联系方式"
              >
                <a-input
                  placeholder="请输入联系方式"
                  v-decorator="[
                    'phoneNumber',
                    {
                      initialValue: data.phoneNumber,
                      rules: [{ validator: this.ValidatePhone, required: true,}],
                    },
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="登录名"
              >
                <a-input
                  :read-only="this.params.isShow"
                  placeholder="请输入登录名"
                  v-decorator="[
                    'userName',
                    {
                      rules: [{ required: true, message: '请输入登录名' }],
                      initialValue: data.userName,
                    },
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="车牌号"
              >
                <a-input
                  :read-only="this.params.isShow"
                  placeholder="请输入车牌号"
                  v-decorator="[
                    'carCard',
                    {
                      rules: [{ required: true, message: '请输入车牌号' }],
                      initialValue: data.carCard,
                    },
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
            class="form-row"
            v-if="!this.params.id"
          >
            <a-col>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="密码"
              >
                <a-input
                  type="password"
                  :read-only="this.params.isShow"
                  placeholder="请输入密码"
                  v-decorator="[
                    'password',
                    {
                      rules: [{ required: true, message: '请输入密码' }],
                      initialValue: data.password,
                    },
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="状态"
              >
                <a-radioGroup
                  :disabled="this.params.isShow"
                  placeholder="请选择状态"
                  v-decorator="[
                    'isActive',
                    {
                      initialValue: data.isActive,
                      rules: [{ required: true, message: '请选择状态' }],
                    },
                  ]"
                >
                  <a-radio value="1">启用</a-radio>
                  <a-radio value="0">禁用</a-radio>
                </a-radioGroup>
              </a-form-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane
          tab="组织机构"
          key="2"
          forceRender
        >
          <a-tree
            checkable
            :treeData="allOrganizations"
            :checkedKeys="grantedOrganizationsData"
            @check="this.onOrgCheck"
            :disabled="this.params.isShow"
          ></a-tree>
        </a-tab-pane>

        <!-- <a-tab-pane tab="负责区域" key="3" forceRender>
          <a-tree checkable checkStrictly :treeData="allDealerGroups" :checkedKeys="responsibleGroups" @check="this.onGroupCheck" :disabled="this.params.isShow"></a-tree>
        </a-tab-pane> -->
      </a-tabs>

      <div
        v-if="!this.params.isShow"
        class="hp-manager-dialog-footer"
      >
        <a-form-item label>
          <a-button
            type="primary"
            @click="submit"
            :loading="loading"
          >确认</a-button>
          <a-button
            style="margin-left: 10px"
            @click="cancel"
          >取消</a-button>
        </a-form-item>
      </div>
    </a-form>
    <hp-manager-modal
      width="1000px"
      :title="'选择员工'"
      v-model="selectEmployeeVisible"
    >
      <hp-manager-page-employee-select
        slot="slot"
        @getSelectedEmployee="getSelectedEmployee"
        @cancel="selectEmployeeVisible = false"
      ></hp-manager-page-employee-select>
    </hp-manager-modal>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import hpManagerPageEmployeeSelect from "./../../Basic/Employee/SelectList";
import validate from "@/mixins/validator";
let allRoles = [];
let checkedRoles = [];

let allOrganizations = [];
let grantedOrganizations = [];

let allDealerGroups = [];
let responsibleGroups = [];

const defaultData = {
  id: 0,
  name: "",
  phoneNumber: "",
  userName: "",
  isActive: "1",
  password: "",
  employeeId: null,
  roleNames: []
};
export default {
  name: "hp-manager-page-user-add",
  mixins: [account, dateFormat, validate],
  components: {
    hpManagerPageEmployeeSelect
  },
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      employeeId: null,
      selectEmployeeVisible: false,
      data: {},
      allRoles: [],
      checkedRoles: [],
      allOrganizations: [],
      //参数（选择的组织）
      grantedOrganizations: [],
      //参数（选择的部门）
      grantedDepartments: [],

      grantedOrganizationsData: [],

      allDealerGroups: [],
      responsibleGroups: [],

      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    // this.getAllGroups();
    await this.getAllDepartments();
    if (this.params.id) {
      this.getdetailUser();
    } else {
      this.data = exzends(defaultData);
    }
    allRoles = this.getAllRoldes();
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    onOrgCheck(checkedKeys, info) {
      console.log(checkedKeys);
      this.grantedOrganizationsData = checkedKeys;
      this.grantedDepartments = [];
      this.grantedOrganizations = [];

      if (this.grantedOrganizationsData != null) {
        this.grantedOrganizationsData.forEach(a => {
          if (a.indexOf("c-")) {
            this.grantedOrganizations.push(a);
          } else {
            this.grantedDepartments.push(a.substring(2));
          }
        });
      }
      console.log("organization", this.grantedOrganizations);
      console.log("department", this.grantedDepartments);
    },

    // onGroupCheck(checkedKeys, info) {
    //   this.responsibleGroups = checkedKeys.checked;
    //   console.log(this.responsibleGroups);
    // },
    ValidatePhone(rule, value, callback) {
      if (value.trim() != "" && !this.isMobile(value)) {
        callback("请输入正确的手机号");
      }
      callback();
    },
    // async GetOrganizationOptions() {
    //   let org = await api.GetOrganizationSelect();
    //   if (org) {
    //     this.allOrganizations = [];
    //     org.forEach(a => {
    //       this.allOrganizations.push({
    //         title: a.text,
    //         key: a.value
    //       });
    //     });
    //   }
    // },
    async getAllDepartments(departmentNode) {
      this.loading = true;
      if (departmentNode != null) {
        departmentNode.forEach(element => {
          this.allOrganizations.push({
            title: element.label,
            key: element.value,
            children: this.setDepartmentChildrenNode(element.children)
          });
        });
      } else {
        let result = await api.GetAllDepartmentData({});
        console.log("result", result);
        if (result) {
          result.forEach(element => {
            this.allOrganizations.push({
              title: element.label,
              key: element.value,
              children: this.setDepartmentChildrenNode(element.children)
            });
          });
        }
      }

      this.loading = false;
    },
    setDepartmentChildrenNode(departmentNode) {
      console.log(departmentNode);
      let childNode = [];
      if (departmentNode && departmentNode.length > 0) {
        departmentNode.forEach(a => {
          childNode.push({
            title: a.label,
            key: "c-" + a.value,
            children: this.setDepartmentChildrenNode(a.children)
          });
        });
      }
      return childNode;
    },

    // setChildrenNode(dealerGropuNode) {
    //   let childNode = [];
    //   if (dealerGropuNode && dealerGropuNode.length > 0) {
    //     dealerGropuNode.forEach(a => {
    //       childNode.push({
    //         title: a.name,
    //         key: a.id,
    //         children: this.setChildrenNode(a.children)
    //       });
    //     });
    //   }
    //   return childNode;
    // },
    // async getAllGroups(dealerGropuNode) {
    //   this.loading = true;
    //   if (dealerGropuNode != null) {
    //     dealerGropuNode.forEach(element => {
    //       this.allDealerGroups.push({
    //         title: element.name,
    //         key: element.id,
    //         children: this.setChildrenNode(element.children)
    //       });
    //     });
    //   } else {
    //     let result = await api.GetAllDealerGroup({});
    //     if (result) {
    //       result.items.forEach(element => {
    //         this.allDealerGroups.push({
    //           title: element.name,
    //           key: element.id,
    //           children: this.setChildrenNode(element.children)
    //         });
    //       });
    //     }
    //   }

    //   this.loading = false;
    // },

    onRoleChange(checkedValues) {
      this.checkedRoles = checkedValues;
    },
    onEmployeeSearch() {
      this.selectEmployeeVisible = true;
    },
    getSelectedEmployee(p) {
      this.selectEmployeeVisible = false;
      this.form.setFields({ name: { value: p.name, errors: null } });
      this.form.setFields({
        phoneNumber: { value: p.telephone, errors: null }
      });
      this.employeeId = p.id;
      if (p.organizationId && p.organizationId > 0) {
        if (
          !this.grantedOrganizations.filter(a => a == p.organizationId + "")[0]
        ) {
          this.grantedOrganizations.push(p.organizationId + "");
        }
      }
    },
    async getdetailUser() {
      this.loading = true;
      let result = await api.GetUser({ Id: this.params.id });
      if (result) {
        this.data = result;
        this.data.name = this.data.name;
        this.data.userName = this.data.userName;
        this.data.phoneNumber = this.data.phoneNumber;
        this.data.roleNames = this.data.roleNames;
        this.checkedRoles = this.data.roleNames;
        this.data.isActive = (this.data.isActive ? 1 : 0) + "";
        this.employeeId = this.employeeId;

        // this.responsibleGroups=this.data.grantedDealerGroups;
        // this.grantedOrganizations
        if (this.data.grantedOrganizations != null) {
          this.data.grantedOrganizations.forEach(a => {
            this.grantedOrganizations.push(a + "");
            this.grantedOrganizationsData.push(a + "");
          });
        }
        if (this.data.grantedDepartments != null) {
          this.data.grantedDepartments.forEach(a => {
            this.grantedDepartments.push(a + "");
            this.grantedOrganizationsData.push("c-" + a);
          });
        }
      }
      this.loading = false;
    },
    async getAllRoldes() {
      this.loading = true;
      let result = await api.GetRoles({});
      if (result) {
        result.items.forEach(element => {
          this.allRoles.push({
            name: element.name,
            displayName: element.displayName
          });
        });
      }
      this.loading = false;
    },
    async submitHandler() {
      await api.AddOrUpdateUser(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        userName: value.userName,
        phoneNumber: value.phoneNumber,
        password: value.password,
        userType: 4,
        roleNames: ["司机"],
        employeeId: this.employeeId,
        isActive: parseInt(value.isActive) == 1,
        grantedOrganizations: this.grantedOrganizations,
        grantedDepartments: this.grantedDepartments,
        carCard: value.carCard
        //grantedDealerGroups:this.responsibleGroups,
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.UpdateUser(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddUser(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Admins/Driver/Add.vue